import { hasForms2, scrollToY } from "../../js/helpers";

class MarketoRegister {

    constructor(block) {
        this.isPaginated = false;
        this.BLOCK = block;
        this.FORM = block.find('form');
        this.ANIM_SPEED= 300;
        this.PREFIX = 'marketo-register-form';
        this.ARROW = `<span class="ico ico-arrow ico--small ico--deep-blue"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15.71 2.29l-1.42 1.42L25.59 15H3v2h22.59l-11.3 11.29 1.42 1.42L29.41 16 15.71 2.29z"/></svg></span>`;

        this.pages = [];
        this.currentPageNum = 0;

        this.mq = window.matchMedia("(max-width: 1024px)");

        // if form has been submitted lets show the success message
        if (this.FORM.attr('data-submitted') == "1") {
            this.FORM.find('.mktoFormRow').hide();

            this.FORM.find('.form-confirm')
                .show()
                .parents('.mktoFormRow')
                    .show();

            setTimeout(() => {
                scrollToY(this.BLOCK.offset().top - 100, 0);
            }, 100);

        } else {
            // If the form isn't already initialised, let's set it up
            if (!this.BLOCK.hasClass('has-init')) {
                // LET's DO THIS!
                this.preparePages();
                this.prepareNameField();
                this.prepareCheckboxField();
                this.prepareFieldBrackets();
                this.prepareEmailField();

                // Only try to go to a page if the form is actually paginated
                if (this.isPaginated) {
                    this.gotoPage(this.currentPageNum, false, false);
                }

                this.BLOCK.addClass('has-init');
            }
        }

        // Remove empty spacer divs created by Marketo
        this.FORM.find('.mktoOffset, .mktoGutter').remove();

        // If the form is paginated, hide the default submit button
        if (this.isPaginated) {
            this.FORM.find('> .mktoButtonRow').hide();
        }

        this.BLOCK.find('.loading').removeClass('loading'); // we're done, show let's start!
    }

    isPageValid() {
        const page = $(this.pages[this.currentPageNum]);
        if (page) {
            const invalidFields = page.find('.mktoField.mktoInvalid');
            const emptyRequiredFields = page.find('.mktoField.mktoRequired').filter(function() { // return .mktoRequired with no value - filtering is more robust than $(x[value=""])
                return !this.value;
            });
            const emptyRequiredRadios = page.find('.mktoRadioList.mktoRequired').filter(function() { // find any .mktoRadioList with unchecked radio children
                return !$(this).find('input[type=radio]').is(':checked');
            });

            const emptyRequiredChecks = page.find('.mktoCheckboxList.mktoRequired').filter(function() { // find any .mktoRadioList with unchecked radio children
                return !$(this).find('input[type=checkbox]').is(':checked');
            });

            if (invalidFields.length > 0) {
                invalidFields.first().focus();
                return false;
            }

            if (emptyRequiredFields.length > 0) {
                emptyRequiredFields.first().focus();
                return false;
            }

            if (emptyRequiredRadios.length > 0) {
                emptyRequiredRadios.first().find('input[type=radio]').first() // find the first radio in the first empty match.
                    .focus().blur().focus(); // focus then blur it to trigger marketo validation, then focus again for the users benefit
                return false;
            }

            // not very DRY repeating above, feel free to functionify it...
            if (emptyRequiredChecks.length > 0) {
                emptyRequiredChecks.first().find('input[type=checkbox]').first()
                    .focus().blur().focus();
                return false;
            }

            return true;
        }

        return false;
    }

    gotoPage(pageNum, shouldValidate=true, shouldAnimate=true) {

        const animSpeed = shouldAnimate ? this.ANIM_SPEED : 0;

        if (!shouldValidate || (shouldValidate && this.isPageValid(this.currentPageNum))) {

            // if the last page has validated, submit
            if (pageNum >= this.pages.length) {
                this.FORM.addClass('loading');
                this.FORM.find('button[type=submit]').trigger('click');
            } else {
                if (pageNum > 0) {
                    this.hidePage(this.currentPageNum, animSpeed);
                    this.showPage(pageNum, animSpeed);

                    if (this.mq.matches) {
                        this.FORM.find($(`.${this.PREFIX}__html`)).slideUp(300); // hide any HTML on mobile
                    }
                // hide other pages and show the first one
                } else {
                    this.pages.slideUp(animSpeed);
                    this.showPage(pageNum, animSpeed);

                    if (this.mq.matches) {
                        this.FORM.find($(`.${this.PREFIX}__html`)).slideDown(300);
                    }
                }

                // if on mobile or past the first (short) page lets scroll back up
                if ((this.mq.matches && shouldAnimate)) {
                    setTimeout(() => {
                        const newY = $(this.FORM).offset().top - 100;
                        scrollToY(newY);
                    }, animSpeed);
                }
                this.currentPageNum = pageNum;

                // on desktop we wanna "open" out the form container
                if (!this.mq.matches) {
                    if (pageNum > 0) {
                        this.BLOCK.addClass('open');
                    } else {
                        this.BLOCK.removeClass('open');
                    }
                }
            }
        }
    }

    hidePage(pageNum, animSpeed) {
        const page = $(this.pages[pageNum]);
        //if (pageNum > 0) {
            page.slideUp(animSpeed)
            .animate({
                opacity: 0,
                queue: false
            }, animSpeed, () => {
                page.hide();
                page.removeClass('current');
            })
        //}

    }

    showPage(pageNum, animSpeed) {
        $(this.pages[pageNum])
            .slideDown(animSpeed)
            .animate({
                opacity: 1,
                queue: false
            }, animSpeed)
            .addClass('current');

    }

    // break each fieldset into "pages"
    preparePages() {
        const PAGE_SELECTOR = `${this.PREFIX}__page`;

        this.FORM.find('> .mktoFormRow fieldset').each((index, row) => {
            $(row).parents('.mktoFormRow')
                .addClass(PAGE_SELECTOR)
                .attr('data-page', index) // pagenums are index0
        });

        this.pages = $(`.${PAGE_SELECTOR}`);

        if (this.pages.length === 0) {
            this.isPaginated = false;
            return;
        }
        this.isPaginated = true;

        this.pages.first().addClass(`${this.PREFIX}__page--email first`);
        this.pages.last().addClass('last');

        this.pages.each((index, page) => {
            const fieldset = $(page).find('fieldset');

            // Create a wrapper to contain the navigation buttons.
            let pageNavButtonWrap = $($('<div>')).addClass(`${this.PREFIX}__button-wrap`);

            // Add prev button to all except first page
            if (index > 0) {
            let prevPageButton = this.pageNavButton('prev')
                .addClass('prev button button--deep-blue filled')
                .attr('aria-label', 'previous form page');
                pageNavButtonWrap.append(prevPageButton);
            }

            // Add submit button to final page
            if (index + 1 == this.pages.length) {
                //Check if forms submit button has alternative text
                let submitText = 'Submit';
                if (this.FORM.find('> .mktoButtonRow').text().toLowerCase() !== 'submit') {
                    submitText = this.FORM.find('> .mktoButtonRow').text();
                }

                let pageSubmitButton = this.pageNavButton('next')
                    .addClass('next submit button button--deep-blue filled')
                    .attr('aria-label', 'submit form')
                    .text(submitText);
                pageNavButtonWrap.append(pageSubmitButton);
            }

            // Add next buttton to all except last page
            if (index < this.pages.length - 1) {
                let nextPageButton = this.pageNavButton('next')
                    .addClass('next button button--deep-blue filled')
                    .attr('aria-label', 'next form page');
                pageNavButtonWrap.append(nextPageButton);
            }

            // Append the page nav to the fieldset
            $(fieldset).append(pageNavButtonWrap);
        });
    }


    prepareEmailField() {
        const email = this.FORM.find('#Email');
        const emailParent = email.parent('.mktoFieldWrap');
        if ($('[block-name="marketo-register"]').length) {
            //check for marketo register
            emailParent.addClass('mktoFieldWrap--email');
        }
    }

    /*
    fieldsets can't be flex containers so we need to wrap the name fields in divs:
    https://stackoverflow.com/questions/28078681/why-cant-fieldset-be-flex-containers
     */
    prepareNameField() {
        const nameFieldsRow = this.FORM.find('#FirstName, #LastName').closest('.mktoFormRow');

        //append to page if fieldset exists
        if(nameFieldsRow.parent().is('fieldset')) {
            nameFieldsRow.closest('fieldset').prepend(
                $('<div>')
                    .addClass(`${this.PREFIX}__name-wrap`)
                    .html(nameFieldsRow)
            );
        }
    }

    prepareFieldBrackets() {
        this.FORM.find('.mktoRadioList label').each((index, field) => {
            const text = $(field).html();
            const match = text.match(/\(([^)]+)\)/);

            if (match) {
                let span = $('<span>').html(`(${match[1]})`);
                $(field).html(text.replace(match[0], ' '))
                    .append(span);
            }
        });
    }

    pageNavButton(prevOrNext) {
        return  $('<button>')
            .addClass(`${this.PREFIX}__button`)
            .html($(this.ARROW))
            .on('click', (e) => { // use .one to make sure it only fires once
                let nextPageNum = this.currentPageNum;
                nextPageNum = prevOrNext === 'next' ? nextPageNum+1 : nextPageNum-1;
                this.gotoPage(nextPageNum, prevOrNext === 'next');
                return false;
            });
    }

    prepareCheckboxField() {
        this.FORM.find('.mktoCheckboxList')
            .parents('.mktoFieldWrap')
            .addClass('mktoFieldWrap--checkbox')
    }
}

(function($) {
    $(() => {
        var formType = $('[block-name="marketo-register"], .landing-page-form')
        if (hasForms2() && formType) {
            $(formType).map((index, block) => {
                const id = $(block).find('form').attr('data-form-id');
                if (id) {
                    MktoForms2.loadForm("//learn.navitas.com", "007-GQS-374", id, function () {
                        let reg = new MarketoRegister($(block));
                    });
                }
            });
        }
    });
})(jQuery);


